export default "__VITE_ASSET__ZrJXgrPc__"